import CircleIcon from "@mui/icons-material/Circle";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useTheme
} from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
export interface ConfidenceIntervalCardProps {
  confidenceInterval: number;
  maxConfidenceInterval?: number;
}

const ConfidenceIntervalCard = ({
  confidenceInterval,
  maxConfidenceInterval = 5
}: ConfidenceIntervalCardProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const intervalDots = useMemo(
    () =>
      Array.from({ length: maxConfidenceInterval }, (_, index) => (
        <CircleIcon
          key={index}
          sx={{
            color:
              index < confidenceInterval
                ? theme.palette.primary.main
                : theme.palette.customColors.dotInactiveColor
          }}
        />
      )),
    [
      confidenceInterval,
      maxConfidenceInterval,
      theme.palette.primary.main,
      theme.palette.customColors.dotInactiveColor
    ]
  );

  return (
    <Card className="w-full">
      <CardContent>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 12, md: 3 }}>
            <Grid
              container
              spacing={2}
              justifyContent="left"
              className="font-bold pt-2"
            >
              {t("simulator.scenario.result")}
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 9 }}>
            <Box className="flex items-center justify-end gap-4 w-full">
              <Box className="flex items-center">
                {t("simulator.scenario.confidence_interval")}
              </Box>
              <Box className="flex items-center">{intervalDots}</Box>
              <Typography variant="h6" color="primary">
                {confidenceInterval}/{maxConfidenceInterval}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ConfidenceIntervalCard;
